/*
 * _MobileSdkTemplate
 */

const _MobileSdkTemplate = {

};

export default _MobileSdkTemplate;
